module.exports = __webpack_public_path__ + "static/EmergingLeaders-logoImg-102c5fd74d0ba4698dca5f68d6469a59.jpg";